import React, { useEffect, useState } from 'react'; 
import ListTemplate from '../../../Reusable_Components/ListTemplate';  
import axios from 'axios'; 
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';  

const TaxFilingListDetails = () => { 
  const [taxFilings, setTaxFilings] = useState([]); 
  
  useEffect(() => { 
            
    fetchTaxFilings(); 
  }, []); 
  
  const fetchTaxFilings = async () => { 
    try { 
      const url = `${API_DOMAIN}${API_ROUTES.tax_filing}`; 
      const token = localStorage.getItem('token'); 
       
      const response = await axios.get(url, { headers }); 
      const taxFilingsWithTypeName = await Promise.all(response.data.map(async (taxFiling) => {
        const taxType = await fetchTaxType(taxFiling.tax_type);
        return { ...taxFiling, tax_type_name: taxType.name };
      }));
      setTaxFilings(taxFilingsWithTypeName); 
    } catch (error) { 
      console.error('Error fetching tax filings:', error); 
    } 
  };

  const fetchTaxType = async (taxType) => { 
    try {
      const url = `${API_DOMAIN}${API_ROUTES.tax_type}${taxType}/`; 
      const token = localStorage.getItem('token'); 
       
      const response = await axios.get(url, { headers }); 
      return response.data; 
    } catch (error) { 
      console.error('Error fetching tax types:', error); 
    } 
  };

  const columns = [ 
    { label: 'Tax Type', value: 'tax_type_name' }, 
    { label: 'Filing Date', value: 'filing_date' }, 
    { label: 'Filing Period', value: 'filing_period' }, 
    { label: 'Amount Filed', value: 'amount_filed' }, 
    { label: 'Status', value: 'status' }, 
  ]; 

  const handleViewDetails = (taxFilingId) => { 
    //console.log('View Details', taxFilingId); 
    const encodedId = btoa(taxFilingId); 
    window.location.href = `/tax/filing/details/${encodedId}`; 
  }; 

  const handleEditDetails = (taxFilingId) => {
    const encodedId = btoa(taxFilingId); 
    window.location.href = `/tax/filing/input/${encodedId}`;
  };

  const actionButtons = [ 
    { label: 'Edit Details', handler: handleEditDetails }, 
  ]; 

  return <ListTemplate columns={columns} data={taxFilings} actionButtons={actionButtons} />; 
}; 

export default TaxFilingListDetails;